import React from 'react'
import styles from '../../styles.module.scss'
import TableRow from '../TableRow'
import { Link } from '@tanstack/react-location'
import Button from 'shared/components/Button'
import { objectCopy } from 'shared/helpers/general'
import { smartSort } from 'shared/helpers/arrays'

function ManagePropertyLinesSection({ property, onRefresh, onUnitTypeConfigurationChange }) {
  return (
    <>
      <div className="flex justify-between items-center mt-[16px]">
        <div className="text-xl">Lines</div>
        <div className="flex justify-end">
          <Link to={`/line/add?property_id=${property.id}`}>
            <Button size="small" rounded variant="secondary">
              Add line
            </Button>
          </Link>
        </div>
      </div>
      <div className={`data-table mt-[16px]`}>
        <table className={`table w-full`}>
          <thead>
            <tr className={styles.header}>
              <th>Line</th>
              <th>Units</th>
              <th>Designs</th>
              <th>Floor plan</th>
              <th>Walkthrough video</th>
              <th>Images</th>
               <th>Building name <br/><span className='text-[10px] opacity-50'>Showing unique only</span></th>
              <th>Ready to Publish</th>
              <th>Tour Page Emails</th>
            </tr>
          </thead>

          {objectCopy(property.unit_types).sort(smartSort('name'))
            // .filter((t) => t.unit_type_levels.length > 0)
            .map((unit_type) => (
              <TableRow
                property={property.id}
                unitType={unit_type}
                onDelete={() => {
                  onRefresh()
                }}
                onUnitTypeConfigurationChange={onUnitTypeConfigurationChange}
              />
            ))}
        </table>
      </div>
    </>
  )
}

export default ManagePropertyLinesSection
